export function useModal(INITIAL_MODAL_STATUS: boolean = false) {
    const modal = ref(INITIAL_MODAL_STATUS)

    const toggleModal = () => {
        modal.value = !modal.value
    }

    const openModal = () => {
        modal.value = true
    }
    const closeModal = () => {
        modal.value = false
    }

    return { modal, toggleModal, openModal, closeModal }
}
